import Backend from "../../../Backend";

export const getJob = (id) =>
  Backend.get(`api/jobs/${id}`);

export const createJob = (job) =>
  Backend.post("api/jobs/create", job);

export const updateJob = (id, job) =>
  Backend.put(`api/jobs/${id}`, job);

export const getJobsList = (params = {}) =>
  Backend.post("api/jobs/list", {
    page: params.page || 0,
    pageSize: params.pageSize || 10,
    searchTerm: params.searchTerm || "",
    statusFilter: params.statusFilter || "All",
    sortBy: params.sortBy || null,
  });

export const deleteJob = (id) =>
  Backend.delete(`api/jobs/${id}`);

// Product operations (uses /materials API endpoint for backwards compatibility)
export const addProductToJob = (jobId, product) =>
  Backend.post(`api/jobs/${jobId}/materials`, product);

export const removeProductFromJob = (jobId, productId) =>
  Backend.delete(`api/jobs/${jobId}/materials/${productId}`);

export const updateProductInJob = (jobId, productId, updates) =>
  Backend.put(`api/jobs/${jobId}/materials/${productId}`, updates);

// Legacy aliases for backwards compatibility
export const addMaterialToJob = addProductToJob;
export const removeMaterialFromJob = removeProductFromJob;
export const updateMaterialInJob = updateProductInJob;
